/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Aquishop : recherche instantanee. Toute requete de recherche predictive du theme (section predictive-search)
   passe par /search/suggest avec 6 resultats par type (limit_scope=each) : produits, categories, articles, pages.
   Le tri et les plafonds par type (6 / 4 / 3 / 2) sont faits dans sections/predictive-search.liquid. */
(function () {
  var TYPES = 'product,collection,article,page';
  var LIMIT = '6';

  function rewrite(input) {
    try {
      var url = new URL(input, window.location.origin);
      if (url.origin !== window.location.origin) return null;
      if (url.searchParams.get('section_id') !== 'predictive-search') return null;
      var path = url.pathname;
      if (!/\/search(\/suggest)?$/.test(path)) return null;
      var q = url.searchParams.get('q') || '';
      if (q.indexOf('product_type:') !== -1) return null; /* filtre par type : on garde la recherche classique du theme */
      if (!/\/suggest$/.test(path)) {
        url.pathname = path + '/suggest';
        url.searchParams.delete('type');
        url.searchParams.delete('view');
        url.searchParams.delete('options[prefix]');
        url.searchParams.set('q', q.replace(/\*$/, ''));
      }
      url.searchParams.set('resources[type]', TYPES);
      url.searchParams.set('resources[limit]', LIMIT);
      url.searchParams.set('resources[limit_scope]', 'each');
      url.searchParams.set('resources[options][unavailable_products]', 'last');
      return url.pathname + url.search;
    } catch (e) {
      return null;
    }
  }

  if (window.fetch) {
    var nativeFetch = window.fetch;
    window.fetch = function (input, init) {
      var raw = typeof input === 'string' ? input : (input && input.url);
      var next = raw ? rewrite(raw) : null;
      if (next) {
        input = typeof input === 'string' ? next : new Request(next, input);
      }
      return nativeFetch.call(this, input, init);
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var next = typeof url === 'string' ? rewrite(url) : null;
    if (next) arguments[1] = next;
    return nativeOpen.apply(this, arguments);
  };
})();


/* Aquishop : recherche mobile. La zone de resultats prend exactement la hauteur visible de l'ecran
   (sous l'en-tete et au-dessus du clavier) pour pouvoir defiler jusqu'au dernier resultat. */
(function () {
  var mq = window.matchMedia('(max-width: 640px)');
  var SCROLLERS = ['.search-bar__results', '.search-bar__menu-wrapper'];

  function fit() {
    if (!mq.matches) return;
    var vh = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    var inners = document.querySelectorAll('.search-bar__inner');
    for (var i = 0; i < inners.length; i++) {
      var inner = inners[i];
      var top = inner.getBoundingClientRect().top;
      if (top < 0 || top > vh) continue;
      var h = Math.max(160, Math.round(vh - top));
      inner.style.setProperty('height', h + 'px', 'important');
      inner.style.setProperty('max-height', h + 'px', 'important');
      for (var j = 0; j < SCROLLERS.length; j++) {
        var el = inner.querySelector(SCROLLERS[j]);
        if (!el) continue;
        el.style.setProperty('height', '100%', 'important');
        el.style.setProperty('max-height', h + 'px', 'important');
        el.style.setProperty('overflow-y', 'auto', 'important');
        el.style.setProperty('-webkit-overflow-scrolling', 'touch');
        el.style.setProperty('overscroll-behavior', 'contain');
        el.style.setProperty('padding-bottom', '32px');
        if (!el.__aqsTouch) {
          el.__aqsTouch = true;
          el.addEventListener('touchmove', function (e) {
            if (this.scrollHeight > this.clientHeight) e.stopPropagation();
          }, { passive: true });
        }
      }
    }
  }

  function later() { fit(); setTimeout(fit, 120); setTimeout(fit, 450); }

  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('.search-bar')) later(); });
  document.addEventListener('input', function (e) { if (e.target.closest && e.target.closest('.search-bar')) later(); });
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-action="toggle-search"], .header__action-item--search, .search-bar')) later(); });
  window.addEventListener('resize', later);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', fit);

  function observe() {
    var targets = document.querySelectorAll('.search-bar__results-inner, .search-bar');
    if (!targets.length || !window.MutationObserver) return;
    var mo = new MutationObserver(later);
    for (var k = 0; k < targets.length; k++) {
      mo.observe(targets[k], { childList: true, attributes: true, attributeFilter: ['class', 'aria-hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe); else observe();
})();
